export default __webpack_public_path__ + "static/genopets-4-e4b74aebfb04e661c848d0dff7218c1f.webp";